export default "__VITE_ASSET__duF$1Jum__"